<template>
  <ol-map
    ref="map"
    :loadTilesWhileAnimating="true"
    :loadTilesWhileInteracting="true"
    @click="selectLocationCallback"
    :style="{height: heightStyle + 'px'}"
  >
    <ol-view
      ref="view"
      :center="center"
      :rotation="rotation"
      :zoom="zoom"
      :projection="projection"
    />

    <ol-tile-layer ref="osmLayer" title="OSM">
      <ol-source-osm />
    </ol-tile-layer>

    <ol-overviewmap-control>
      <ol-tile-layer>
        <ol-source-osm />
      </ol-tile-layer>
    </ol-overviewmap-control>

    <ol-scaleline-control />
    <ol-rotate-control />
    <ol-zoom-control />
    <ol-zoomslider-control />
    <ol-zoomtoextent-control
      :extent="[19.5, 49.25, 20.45, 48.92]"
      tipLabel="Fit to Tatry"
    />

    <ol-context-menu :items="contextMenuItems" />
    <ol-interaction-dragrotatezoom />

    <ol-vector-layer
      :updateWhileAnimating="true"
      :updateWhileInteracting="true"
    >
      <ol-source-vector ref="vectorsource"> </ol-source-vector>
    </ol-vector-layer>
  </ol-map>
</template>

<script>
import { ref, inject, onMounted } from 'vue'
// import Feature from 'ol/Feature'
import { transform } from 'ol/proj'

import markerIcon from '@/assets/marker.png'
import starIcon from '@/assets/star.png'

export default {
  data() {
    return {
      heightStyle: '800'
    }
  },

  methods: {
    reloadMap() {
      this.$refs.map.updateSize()
    }
  },

  props: {
    selectedLocation: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:selectedLocation'],

  setup(props, { emit }) {
    const center = ref(transform([20.02, 49.02], 'EPSG:4326', 'EPSG:3857'))
    const projection = ref('EPSG:3857')
    const zoom = ref(10)
    const rotation = ref(0)

    const format = inject('ol-format')

    const geoJson = new format.GeoJSON()

    // const selectConditions = inject('ol-selectconditions')

    // const selectCondition = selectConditions.pointerMove

    const Feature = inject('ol-feature')
    const Geom = inject('ol-geom')

    const contextMenuItems = ref([])
    const vectorsource = ref(null)
    const view = ref(null)

    const drawEnable = ref(false)
    const drawType = ref('Point')

    const changeDrawType = (active, draw) => {
      drawEnable.value = active
      drawType.value = draw
    }

    const selectLocationCallback = function(val) {
      if (
        undefined === val.coordinate ||
        val.coordinate === null ||
        val.coordinate === ''
      ) {
        return
      }
      emit(
        'update:selectedLocation',
        transform(val.coordinate, 'EPSG:3857', 'EPSG:4326')
      )
      const feature = new Feature({
        geometry: new Geom.Point(val.coordinate)
      })
      vectorsource.value.source.clear()
      vectorsource.value.source.addFeature(feature)
    }

    contextMenuItems.value = [
      {
        text: 'Add a Marker',
        icon: markerIcon, // this can be relative or absolute
        callback: selectLocationCallback
      },
      '-' // this is a separator
    ]

    const overrideStyleFunction = (feature, style) => {
      const clusteredFeatures = feature.get('features')
      const size = clusteredFeatures.length

      const color = size > 20 ? '192,0,0' : size > 8 ? '255,128,0' : '0,128,0'
      const radius = Math.max(8, Math.min(size, 20))
      const dash = (2 * Math.PI * radius) / 6
      const calculatedDash = [0, dash, dash, dash, dash, dash, dash]

      style
        .getImage()
        .getStroke()
        .setLineDash(dash)
      style
        .getImage()
        .getStroke()
        .setColor('rgba(' + color + ',0.5)')
      style
        .getImage()
        .getStroke()
        .setLineDash(calculatedDash)
      style
        .getImage()
        .getFill()
        .setColor('rgba(' + color + ',1)')

      style.getImage().setRadius(radius)

      style.getText().setText(size.toString())
    }

    const selectInteactionFilter = feature => {
      return feature.values_.name != undefined
    }

    const getRandomInRange = (from, to, fixed) => {
      return (Math.random() * (to - from) + from).toFixed(fixed) * 1
    }

    const drawstart = event => {
      console.log(event)
    }

    const drawend = event => {
      console.log(event)
    }

    const modifystart = event => {
      console.log(event)
    }

    const modifyend = event => {
      console.log(event)
    }

    const videoStopped = event => {
      console.log(event)
    }

    const swipeControl = ref(null)
    const jawgLayer = ref(null)
    const osmLayer = ref(null)
    const layerList = ref([])

    onMounted(() => {
      console.log(layerList.value)
    })

    return {
      center,
      projection,
      zoom,
      rotation,
      geoJson,
      markerIcon,
      overrideStyleFunction,
      getRandomInRange,
      contextMenuItems,
      vectorsource,
      view,
      selectInteactionFilter,
      drawstart,
      drawend,
      modifystart,
      modifyend,
      videoStopped,
      drawEnable,
      drawType,
      layerList,
      jawgLayer,
      swipeControl,
      osmLayer,
      starIcon,
      changeDrawType,
      selectLocationCallback
    }
  }
}
</script>
